import { useState, useEffect } from 'react';
import { Card, Skeleton, Form, Input, Select, Upload, Button, Switch, Tree, Modal, message, Tag, TreeSelect, Spin, Popconfirm } from 'antd';
import { FolderViewOutlined, DeleteOutlined, WarningOutlined, EditOutlined, FileExclamationOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useLocation, NavLink } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import _ from 'lodash';




const { Option } = Select;
const { Dragger } = Upload;
const { DirectoryTree } = Tree;


const Product = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [products, setProducts] = useState([]);
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [treeVisibleData, setTreeVisibleData] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const [catTree, setCatTree] = useState([]);
  const [dontMount, setDontMount] = useState(false);
  const [categoriesByDept, setCategoriesByDept] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [switchValue, setSwitchValue] = useState(true);
  const [userRole, setUserRole] = useState("");
  const [error, setError] = useState();
  const [loadingProduct, setLoadingProduct] = useState(false);
  const [editProductUuid, setEditProductUuid] = useState();
  const [fileListA, setFileListA] = useState([]);






  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['blockquote', 'code-block'],
      [{ script: 'sub' }, { script: 'super' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['image'],
      ['clean'],
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'code-block',
    'list',
    'bullet',
    'script',
    'indent',
    'direction',
    'color',
    'background',
    'font',
    'align',
    'image',
    'clean',
  ];

  useEffect(() => {
    getTreeProducts();
    getTreeVisible();
    getCategoriesByDept()
  }, []);

  useEffect(() => {

    getProducts();
    getMenu();


    setDontMount(false)

  }, [props, location.search]);

  useEffect(() => {
    const paramValue = searchParams.get('prMod');
    paramValue ? setOpen(true) : setOpen(false);
  }, [])


  useEffect(() => {
    // Filter and update the state when the component mounts
    if (!dontMount) {
      const filteredData = treeData.filter(obj => {
        const categoryValue = obj.value;
        return products.some(item => item.category === categoryValue);
      });

      setCatTree(filteredData);
    }
  }, [products]);



  const getProducts = async () => {
    let productParam = searchParams.get('d');
    const session = sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")) : null;
    const userString = session ? session.uuid : '';
    const role = session ? session.role : ''
    setUserRole(role)
    const filteredItems = session ? JSON.parse(session.departrment).filter(item => item.length > 36) : null;
    const compareSessDeptInUrl = filteredItems ? filteredItems.map(item => item.split('-').slice(0, 5).join('-')) : null;
    const subDeptFromSess = filteredItems ? filteredItems.map(item => item.split('-').slice(-5).join('-')) : null;
    if (filteredItems) {
      compareSessDeptInUrl.forEach((value, index) => {
        if (value === productParam) {
          console.log(`Found a match at index ${index}`);
        }
      });
    }

    let menuParam = searchParams.get('mEnc');

    try {
      let response;

      if (productParam) {
        response = await axios.post(`${process.env.REACT_APP_API_URL}/products_page`, { productParam, role });
      } else {
        response = await axios.post(`${process.env.REACT_APP_API_URL}/products_page`, { menuParam });
      }
      // console.log('product data api', response.data)
      setProducts(response.data);
      setLoading(false);
      // console.log('product page api',response.data)
    } catch (error) {
      console.log(error);

      console.error(error.response.data.msg);
      // message.error(error.response.data.msg);
      setError(error.response.data.msg);
      setTimeout(function () {
        setError();
      }, 3000);

    }
  };


  const getTreeProducts = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/tree_category`);
      const filteredResponse = response.data.map(item => ({
        ...item,
        children: item.children.filter(child => child.title !== "all")
      }));
      setTreeData(filteredResponse);

    } catch (error) {
      console.log(error);

    }
  };

  const getCategoriesByDept = async () => {
    const paramValue = searchParams.get('d');
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/sub_departments_by_dept`, { dept: paramValue });
      const data = response.data.subdepartments;
      const newArray = data.filter(item => item.name !== "all");
      setCategoriesByDept(newArray);

    } catch (error) {
      console.log(error);

    }
  };

  const getTreeVisible = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/departments_tree`);

      const filteredResponse = response.data.map(item => ({
        ...item,
        children: item.children.filter(child => child.title !== "all")
      }));
      setTreeVisibleData(filteredResponse)

    } catch (error) {
      console.log(error);

    }
  };

  const getMenu = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/menu`);
      setMenuData(response.data);

    } catch (error) {
      console.log(error);

    }
  };

  const showModal = () => {
    setOpen(true);
  };
  function transformApiResponse(apiResponse) {
    const transformedData = {
      documentType: apiResponse.documentType,
      menu: apiResponse.menu,
      textEditor: apiResponse.textEditor,
      title: apiResponse.title,
      fileUrl: apiResponse.fileUrl.split(',').map((url, index) => ({
        uid: String(index),
        name: url.replace(/\\/g, '/')
      })),
      category: apiResponse.category,
      subCategory: apiResponse.subCategory,
      visibleTo: apiResponse.visibleTo.split(',').map(item => item.replace(/"/g, '')),
      visibleToSubDept: apiResponse.visibleToSubDept.split(',').map(item => item.replace(/"/g, '')),
      publish: apiResponse.publish,
    };

    return transformedData;
  }
  const showModalEdit = async (productId) => {
    setEditProductUuid(productId);
    form1.resetFields();

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/products/${productId}/1`);
      
      const transformedData = transformApiResponse(response.data);
     
      const combinedArray = [...new Set(transformedData.visibleTo.concat(transformedData.visibleToSubDept))];

      // Function to extract the last 5 UUIDs from a string
      function extractLastFiveUUIDs(uuidString) {
        const uuidArray = uuidString.split('-');
        return uuidArray.slice(-5).join('-');
      }

      // Function to recursively find default keys based on UUIDs
      function getDefaultKeys(data, defaultUUIDs, parentKey = '') {
        return data.reduce((defaultKeys, node) => {
          const { value, isLeaf } = node;
          const key = node.key || `${parentKey}-${value}`;

          const lastFiveUUIDs = extractLastFiveUUIDs(value);

          if (defaultUUIDs.includes(lastFiveUUIDs) || defaultUUIDs.includes(key)) {
            defaultKeys.push(key);
          }

          if (!isLeaf && node.children) {
            defaultKeys = defaultKeys.concat(getDefaultKeys(node.children, defaultUUIDs, key));
          }

          return defaultKeys;
        }, []);
      }

      // Get default keys based on specified UUIDs
      const defaultCheckedKeys = getDefaultKeys(treeVisibleData, combinedArray);
      // console.log('getApi',response.data.fileUrl,typeof response.data.fileUrl)
      // console.log('transformedData',transformedData);
      // console.log('defaultCheckedKeys',defaultCheckedKeys);
      // console.log('concat', combinedArray)
      // console.log('treeVisibleData', treeVisibleData)

      setFileListA(transformedData.fileUrl.name !== ''  ? transformedData.fileUrl : null)
      form1.setFieldsValue({
        documentType: transformedData.documentType ? transformedData.documentType : null,
        menu: transformedData.menu,
        spreadsheetLinks: transformedData.spreadsheetLinks ? transformedData.spreadsheetLinks : null,
        textEditor: transformedData.textEditor,
        title: transformedData.title,
        uploadFiles: JSON.stringify(transformedData.fileUrl),
        category: transformedData.category,
        subCategory: transformedData.subCategory,
        visibleTo: defaultCheckedKeys,
        publish: transformedData.publish
      });
      setOpenEdit(true);

      // setOpenEdit(true);
    } catch (error) {
      console.log(error)
    }

  };

  const handleOk = () => {
    form.resetFields();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };
  const handleOkEdit = () => {
    form1.resetFields();
    setOpenEdit(false)
  }

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };
  const onFinishFailedEdit = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const handleCancel = () => {
    form.resetFields();
    setOpen(false);
  };
  const handleCancelEdit = () => {
    form.resetFields();
    setOpenEdit(false);
  };

  const { Meta } = Card;

  const onSelect = async (keys, info) => {
    console.log('Trigger Select', keys);
    const paramValue = searchParams.get('d');

    try {

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/products_by_cat_dept`, { catUuid: keys, dept: paramValue });
      setDontMount(true);
      setProducts(response.data);

    } catch (error) {
      console.log(error);

    }
  };

  const onExpand = (keys, info) => {
    console.log('Trigger Expand', keys, info);
  };

  const onFinish = async (values) => {

    setLoadingProduct(true)

    let depType;
    let newVisibleTo = [];
    let newVisibleToSubDept = [];
    // for category and sub category
    let catType;
    let newCategory;
    let newSubCategory;

    const whichDepType = values.visibleTo.map((item) => item.split("-"));
    const whichCatType = values.category.split("-");

    // console.log('whichDepType', whichDepType);

    if (whichDepType.length) {
      depType = "subDept";
      newVisibleToSubDept = newVisibleToSubDept.concat(
        whichDepType.map((item) => item.slice(-5).join("-"))
      );
      newVisibleTo = newVisibleTo.concat(
        whichDepType.map((item) => item.slice(0, 5).join("-"))
      );
      // newVisibleTo = newVisibleTo.concat(
      //   whichDepType.map((item) => item.slice(0, 5).join("-"))
      // );
    } else {
      depType = "dept";

      // newVisibleToSubDept = newVisibleToSubDept.concat(
      //   whichDepType.map((item) => item.slice(0, 5).join("-"))
      // );
    }

    if (whichCatType.length > 5) {
      catType = "subCat";
      newSubCategory = whichCatType.slice(-5).join("-");
      newCategory = whichCatType.slice(0, 5).join("-");
    } else {
      catType = "cat";
      newCategory = whichCatType.slice(0, 5).join("-");
      newSubCategory = whichCatType.slice(0, 5).join("-");
    }




    //for repeating uuids
    const uniqueVisibleTo = [...new Set(newVisibleTo)];
    const uniqueVisibleToSubDept = [...new Set(newVisibleToSubDept)];

    // console.log("newVisibleTo:", uniqueVisibleTo);
    // console.log("newVisibleToSubDept:", uniqueVisibleToSubDept);

    const newValue = {
      documentType: values.documentType !== undefined ? values.documentType : null,
      menu: values.menu !== undefined ? values.menu : null,
      spreadsheetLinks: values.spreadsheetLinks,
      textEditor: values.textEditor,
      title: values.title,
      uploadFiles: values.uploadFiles,
      category: newCategory,
      subCategory: newSubCategory,
      visibleTo: uniqueVisibleTo,
      visibleToSubDept: uniqueVisibleToSubDept,
      depType: depType,
      catType: catType,
      publish: switchValue
    }

    const formData = new FormData();

    // Append regular files from Drag and Drop area
    fileList.forEach((file) => {
      formData.append('files', file.originFileObj);
    });

    // console.log('form value sending to api', newValue)
    try {
      // Append other form values to the FormData
      for (const key in newValue) {
        formData.append(key, newValue[key]);
      }

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/products`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      // console.log('Product created:', response.data);
      form.resetFields();
      getProducts();
      handleCancel();
      setFileList([]);
      setLoadingProduct(false)

    } catch (error) {

      setError(error.response.data.msg);
      setTimeout(function () {
        setError();
      }, 3000);
    }
  };



  const onFinishEdit = async (values) => {


    // console.log('finFOrm', values)
    setLoadingProduct(true)

    let depType;
    let newVisibleTo = [];
    let newVisibleToSubDept = [];
    // for category and sub category
    let catType;
    let newCategory;
    let newSubCategory;

    const whichDepType = values.visibleTo.map((item) => item.split("-"));
    const whichCatType = values.category.split("-");

    // console.log('whichDepType', whichDepType);

    if (whichDepType.length) {
      depType = "subDept";
      newVisibleToSubDept = newVisibleToSubDept.concat(
        whichDepType.map((item) => item.slice(-5).join("-"))
      );
      newVisibleTo = newVisibleTo.concat(
        whichDepType.map((item) => item.slice(0, 5).join("-"))
      );
      // newVisibleTo = newVisibleTo.concat(
      //   whichDepType.map((item) => item.slice(0, 5).join("-"))
      // );
    } else {
      depType = "dept";

      // newVisibleToSubDept = newVisibleToSubDept.concat(
      //   whichDepType.map((item) => item.slice(0, 5).join("-"))
      // );
    }

    if (whichCatType.length > 5) {
      catType = "subCat";
      newSubCategory = whichCatType.slice(-5).join("-");
      newCategory = whichCatType.slice(0, 5).join("-");
    } else {
      catType = "cat";
      newCategory = whichCatType.slice(0, 5).join("-");
      newSubCategory = whichCatType.slice(0, 5).join("-");
    }




    //for repeating uuids
    const uniqueVisibleTo = [...new Set(newVisibleTo)];
    const uniqueVisibleToSubDept = [...new Set(newVisibleToSubDept)];
    // console.log('before merge',values.uploadFiles);
    // // console.log("newVisibleTo:", uniqueVisibleTo);
    // // console.log("newVisibleToSubDept:", uniqueVisibleToSubDept);
    // const parsedUploadFiles = JSON.parse(values.uploadFiles);
    // const mergedFilePath = _.uniqWith([...fileListA, ...parsedUploadFiles], _.isEqual);
    // console.log('mergedFilePath',fileListA,parsedUploadFiles, mergedFilePath);


    const newValue = {
      documentType: values.documentType !== undefined ? values.documentType : null,
      menu: values.menu !== undefined ? values.menu : null,
      spreadsheetLinks: values.spreadsheetLinks,
      textEditor: values.textEditor,
      title: values.title,
      uploadFiles: values.uploadFiles,
      category: newCategory,
      subCategory: newSubCategory,
      visibleTo: uniqueVisibleTo,
      visibleToSubDept: uniqueVisibleToSubDept,
      depType: depType,
      catType: catType,
      publish: switchValue
    }
    console.log('onFinish', newValue)
    const formData = new FormData();

    // Append regular files from Drag and Drop area
    fileListA.forEach((file) => {
      formData.append('files', file.originFileObj);
    });


    try {
      // Append other form values to the FormData
      for (const key in newValue) {
        formData.append(key, newValue[key]);
      }

      const response = await axios.patch(`${process.env.REACT_APP_API_URL}/products/${editProductUuid}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      form.resetFields();
      getProducts();
      handleCancelEdit();
      setFileList([]);
      setLoadingProduct(false)

    } catch (error) {

      setError(error.response.data.msg);
      setTimeout(function () {
        setError();
      }, 3000);
    }
  };

  const deleteProduct = async (productId) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/products/${productId}`);
      // console.log('Product deleted:', productId);
      getProducts();
    } catch (error) {
      setError(error.response.data.msg);
      setTimeout(function () {
        setError();
      }, 3000);

    }
  };




  const handleFileChange = (info) => {
    setFileList(info.fileList);
  };
  const handleFileChangeEdit = (info) => {
    setFileListA(info.fileList);
  };

  const fetchSubDeptProducts = async (e) => {


    const deptUuid = searchParams.get('d');
    const subDeptUuid = e.target.value;

    try {

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/products_by_dept_subdept`, { deptUuid, subDeptUuid });
      setDontMount(true);
      setProducts(response.data);

    } catch (error) {
      console.log(error);

    }

  }



  const validateGoogleSheetsLink = async (rule, value) => {

    if (!value) {
      return
    }
    else {
      const googleSheetsPattern = /^https:\/\/docs\.google\.com\/spreadsheets+/;

      if (!googleSheetsPattern.test(value)) {
        throw new Error('Please enter a valid Google Sheets link');
      }


    }
  };

  const validateFiles = async (rule, value) => {

    if (!value) {
      return
    }
    else {
      

    }
  };



  const handleTag = async (uuid) => {
   

    try {

      const response = await axios.patch(`${process.env.REACT_APP_API_URL}/products_publish_status`, { uuid: uuid });
      getProducts();
      message.success('Document Status Updated Successfully!');
    } catch (error) {
      console.log(error);
      message.error('Error!');
    }
  }


  return (
    <>
      {error && <div className='errorApi'>{error}</div>}

      <div className='tableTitle productCompTitle'>
        <Input
          className='productSearch'
          type="text"
          placeholder="Search products..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {userRole === 'admin' ? <><Button className='addProduct' type='primary' onClick={showModal}>
          Add Document/Product
        </Button>  </> : null}
      </div>

      <div className='productComponent'>
        <div className='treeView'>
          <h3>Document related Category/Sub-Category.</h3>
          <DirectoryTree onSelect={onSelect} onExpand={onExpand} treeData={catTree} />
        </div>

        <div className="">
          <h3>Document related Sub-Departments.</h3>
          {categoriesByDept ? <div className='catWithDep'>
            {categoriesByDept?.map((items) => (
              <div key={items.uuid}>
                <Button type='dashed'>{items.name}<Input value={items.uuid} type='dashed' onClick={fetchSubDeptProducts}></Input></Button>
              </div>
            ))}

          </div> : null}
          {products.length != 0 ?
            <div className='productDocWrapper'>
              <h3>Documents.</h3>
              <div className='productDetails'>

                {products
                  .filter((product) => product.title.toLowerCase().includes(searchQuery.toLowerCase()))
                  .map((product) => (
                    <Card
                      className={userRole === 'admin' ? 'admin' : 'user'}
                      key={product.uuid}
                      style={{
                        marginTop: 16,
                      }}
                      actions={[

                        <div key='View'>
                          <NavLink to={`/product_view?reqU=${product.uuid}`}> <FolderViewOutlined key='View Detail' /></NavLink>
                        </div>,
                        <>
                          {userRole === 'admin' ? (
                            <Popconfirm
                              title="Are you sure you want to delete this product?"
                              onConfirm={() => deleteProduct(product.uuid)}
                              okText="Yes"
                              cancelText="No"
                            >
                              <div key='Delete'>
                                <DeleteOutlined />
                              </div>
                            </Popconfirm>
                          ) : null}
                        </>

                        ,
                        <>
                          {userRole === 'admin' ? (
                            <Popconfirm
                              title={`Are you sure you want to edit ${product.title}?`}
                              onConfirm={() => showModalEdit(product.uuid)}
                              okText="Yes"
                              cancelText="No"
                            >

                              <EditOutlined />

                            </Popconfirm>

                          ) : null}
                        </>
                        
                      ]}
                    >
                      {product.publish ? <Tag color="green" onClick={() => handleTag(product.uuid)}>PUBLISHED</Tag> : <Tag color="red" onClick={() => handleTag(product.uuid)}>UNPUBLISHED</Tag>}
                      <Skeleton loading={loading} paragraph={{ rows: 2 }} active>
                        <Meta avatar={<FolderViewOutlined />} title={'Title: ' + product.title} description={'Doc Type: ' + product.documentType} />
                      </Skeleton>
                    </Card>
                  ))}

                {products.length ? null : <div className='proError'> Oops! no products found <FileExclamationOutlined /></div>}
              </div>
            </div> : <div className='proError'><WarningOutlined />Sorry no product found for this department</div>}
        </div>



      </div>
      <Modal
        open={open}
        title='Add Document'
        onOk={handleOk}
        width={1000}
        onCancel={handleCancel}
        footer={[
          <Button key='back' onClick={handleCancel}>
            Close
          </Button>,
          <Button disabled={loadingProduct} key='submit' type='primary' htmlType="submit" form='documentForm'>
            Submit
          </Button>,
        ]}
        className='documentModal'
      >
        <Spin size='large' spinning={loadingProduct}  >
          <Form

            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            id="documentForm"
            className="documentForm" // Add an ID to the form
            encType="multipart/form-data"
          >
            <div className='formLayout'>
              <div className='addProductForm'>
                <Form.Item label='Title' name='title' rules={[{ required: true, message: 'Please enter a title' }]}>
                  <Input />
                </Form.Item>


                <Form.Item
                  label='Visible to'
                  name='visibleTo'
                  rules={[{ required: true, message: 'Please select visibility' }]}
                >

                  <TreeSelect
                    showSearch
                    style={{
                      width: '100%',
                    }}
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: 'auto',
                    }}
                    placeholder="Please select"
                    allowClear
                    multiple
                    treeDefaultExpandAll
                    treeNodeFilterProp="title"
                    treeData={treeVisibleData}
                  />
                </Form.Item>

                <Form.Item
                  label='Category'
                  name='category'
                  rules={[{ required: true, message: 'Please select a category' }]}
                >
                  <TreeSelect
                    showSearch
                    style={{
                      width: '100%',
                    }}
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: 'auto',
                    }}
                    placeholder="Please select"
                    allowClear
                    treeDefaultExpandAll
                    treeNodeFilterProp="title"
                    treeData={treeData}
                  />

                </Form.Item>

                <Form.Item label='Menu' name='menu' rules={[{ required: false, message: 'Please select a menu' }]}>
                  <Select
                    style={{
                      width: 120,
                    }}
                    allowClear
                  >
                    {menuData.map((card) => (
                      <Option key={card.uuid} value={card.uuid}>{card.name}</Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item label='Document Type' name='documentType' rules={[{ required: true, message: 'Please select doc type!' }]}>
                  <Select >
                    <Option value='normal'>Normal</Option>
                    <Option value='important'>Important</Option>
                    <Option value='critical'>Critical</Option>
                  </Select>
                </Form.Item>

              </div>
              <Form.Item label='Text Editor' name='textEditor'>
                <ReactQuill
                  modules={modules}
                  formats={formats}
                />

              </Form.Item>
            </div>
            <div>
              <div className='spreadLink'>
                <Form.Item label='Spreadsheet Links' name='spreadsheetLinks' rules={[{ validator: validateGoogleSheetsLink }]}>
                  <Input type='url' placeholder='enter link' />
                </Form.Item>
              </div>
              <Form.Item label='Upload Files' name='uploadFiles' rules={[{ validator: validateFiles }]}>
                <div style={{ padding: '20px' }}>

                  <Dragger
                    fileList={fileList}
                    onChange={handleFileChange}
                    accept=".pdf,.jpg,.jpeg,.png,.xlsx,.docx,.txt,.mp4"
                    multiple
                    maxCount={7} // Adjust the maximum number of files allowed here
                  >
                    <p className="ant-upload-drag-icon">
                      <FolderViewOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag files to this area to upload</p>
                  </Dragger>
                </div>
              </Form.Item>
              <div className='note'>
                <h4>Only below formats are supported*</h4>
                <ul>
                  <li>Images: png, jpeg, gif, bmp, including 360-degree images</li>
                  <li>pdf</li>
                  <li>csv</li>
                  <li>xslx</li>
                  <li>docx</li>
                  <li>Video: mp4, webm</li>
                  <li>Audio: mp3</li>
                </ul>
              </div>
              <Form.Item label='Publish' name='publish' className='publish'>
                <Switch
                  checked={switchValue}
                  onChange={(checked) => setSwitchValue(checked)}
                  defaultChecked={true}
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}

                />
              </Form.Item>
            </div>
          </Form>
        </Spin>
      </Modal>


      <div id='editModal'>
        <Modal
          open={openEdit}
          title='Edit Document'
          onOk={handleOkEdit}
          width={1000}
          onCancel={handleCancelEdit}
          footer={[
            <Button key='back' onClick={handleCancelEdit}>
              Close
            </Button>,
            <Button disabled={loadingProduct} key='submit' type='primary' htmlType="submit" form='documentFormEdit'>
              Submit
            </Button>,
          ]}
          className='documentModal'
        >
          <Spin size='large' spinning={loadingProduct}  >
            <Form

              form={form1}
              onFinish={onFinishEdit}
              onFinishFailed={onFinishFailedEdit}
              autoComplete="off"
              id="documentFormEdit"
              className="documentForm"
              encType="multipart/form-data"
            >
              <div className='formLayout'>
                <div className='addProductForm'>
                  <Form.Item label='Title' name='title' rules={[{ required: true, message: 'Please enter a title' }]}>
                    <Input />
                  </Form.Item>


                  <Form.Item
                    label='Visible to'
                    name='visibleTo'
                    rules={[{ required: true, message: 'Please select visibility' }]}
                  >

                    <TreeSelect
                      showSearch
                      style={{
                        width: '100%',
                      }}
                      dropdownStyle={{
                        maxHeight: 400,
                        overflow: 'auto',
                      }}
                      placeholder="Please select"
                      allowClear
                      multiple
                      treeDefaultExpandAll
                      treeNodeFilterProp="title"
                      treeData={treeVisibleData}
                    />
                  </Form.Item>

                  <Form.Item
                    label='Category'
                    name='category'
                    rules={[{ required: true, message: 'Please select a category' }]}
                  >
                    <TreeSelect
                      showSearch
                      style={{
                        width: '100%',
                      }}
                      dropdownStyle={{
                        maxHeight: 400,
                        overflow: 'auto',
                      }}
                      placeholder="Please select"
                      allowClear
                      treeDefaultExpandAll
                      treeNodeFilterProp="title"
                      treeData={treeData}
                    />

                  </Form.Item>

                  <Form.Item label='Menu' name='menu' rules={[{ required: false, message: 'Please select a menu' }]}>
                    <Select
                      style={{
                        width: 120,
                      }}
                      allowClear
                    >
                      {menuData.map((card) => (
                        <Option key={card.uuid} value={card.uuid}>{card.name}</Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item label='Document Type' name='documentType' rules={[{ required: true, message: 'Please select doc type!' }]}>
                    <Select >
                      <Option value='normal'>Normal</Option>
                      <Option value='important'>Important</Option>
                      <Option value='critical'>Critical</Option>
                    </Select>
                  </Form.Item>

                </div>
                <Form.Item label='Text Editor' name='textEditor'>
                  <ReactQuill
                    modules={modules}
                    formats={formats}
                  />

                </Form.Item>
              </div>
              <div>
                <div className='spreadLink'>
                  <Form.Item label='Spreadsheet Links' name='spreadsheetLinks' rules={[{ validator: validateGoogleSheetsLink }]}>
                    <Input type='url' placeholder='enter link' />
                  </Form.Item>
                </div>
              
                <Form.Item label='Publish' name='publish' className='publish'>
                  <Switch
                    checked={switchValue}
                    onChange={(checked) => setSwitchValue(checked)}
                    defaultChecked={true}
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}

                  />
                </Form.Item>
              </div>
            </Form>
          </Spin>
        </Modal>
      </div>

    </>

  );
};

export default Product;
